// import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../assets/images/users/avatar-7.jpg";
import avatar10 from "../../assets/images/users/avatar-10.jpg";
import userImage from "../../assets/images/users/multi-user.jpg";
import img1 from "assets/images/small/img-1.jpg";
import img2 from "assets/images/small/img-2.jpg";

const chatMessage = [
  {
    direactContact: [
      {
        id: 1,
        roomId: 1,
        status: "Online",
        name: "Lisa Parker",
        image: avatar2,
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
      },
      {
        id: 2,
        roomId: 2,
        status: "Online",
        name: "Frank Thomas",
        image: avatar3,
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
        badge: 8,
      },
      {
        id: 3,
        roomId: 3,
        status: "Offline",
        name: "Clifford Taylor",
        bgColor: "primary",
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
      },
      {
        id: 4,
        roomId: 4,
        status: "Online",
        name: "Janette Caster",
        image: avatar4,
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
      },
      {
        id: 5,
        roomId: 5,
        status: "Online",
        name: "Sarah Beattie",
        image: avatar5,
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
        badge: 5,
      },
      {
        id: 6,
        roomId: 6,
        status: "Offline",
        name: "Nellie Cornett",
        image: avatar6,
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
        badge: 2,
      },
      {
        id: 7,
        roomId: 7,
        status: "Online",
        name: "Chris Kiernan",
        bgColor: "primary",
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
      },
      {
        id: 8,
        roomId: 8,
        status: "Offline",
        name: "Edith Evans",
        bgColor: "primary",
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
      },
      {
        id: 9,
        roomId: 9,
        status: "Offline",
        name: "Joseph Siegel",
        image: avatar7,
        number: "+(256) 2451 8974",
        email: "lisaparker@gmail.com",
        location: "California, USA",
      },
    ]
  },
]

const messages: any[] = [];


  export interface Message {
    id: number;
    roomId: string;
    sender: string;
    createdAt: string;
    usermessages: UserMessage[];
  }
  
  interface UserMessage {
    id: number;
    from_id: number;
    to_id: number;
    msg: string;
    isImages: boolean;
    has_images: string[] | null;
    datetime: string;
  }

  export const fetchMessages = async () => {
    // Simulate fetching data from your backend or database
    const response = await fetch('https://example.com/api/messages');  // Replace this with your actual API URL
    const data = await response.json();
    return data;
  };
const attachements = [
  {
    id: 1,
    foldericon: "ri-folder-zip-line",
    foldername: "App pages.zip",
    foldersize: "2.2MB",
  },
  {
    id: 2,
    foldericon: "ri-file-ppt-2-line",
    foldername: "Velzon admin.ppt",
    foldersize: "2.4MB",
  },
  {
    id: 3,
    foldericon: "ri-folder-zip-line",
    foldername: "Images.zip",
    foldersize: "1.2MB",
  },
  {
    id: 4,
    foldericon: "ri-image-2-line",
    foldername: "bg-pattern.png",
    foldersize: "1.1MB",
  },
];

const chatContactData = [
  {
    id: 1,
    title: 'A',
    contacts: [{ id: 1, name: 'Alice Cruickshank', status: "Online", roomId: 15 }],
  },
  {
    id: 2,
    title: 'B',
    contacts: [{ id: 2, name: 'Barrett Brown', status: "Online", roomId: 16, image: avatar4 }],
  },
  {
    id: 3,
    title: 'C',
    contacts: [
      { id: 3, name: 'Chris Kiernan', status: "Offline", roomId: 7 },
      { id: 4, name: 'Clifford Taylor', status: "Online", roomId: 3 }],
  },
  {
    id: 5,
    title: 'E',
    contacts: [{ id: 5, name: 'Edith Evans', status: "Offline", roomId: 8 }],
  },
  {
    id: 6,
    title: 'F',
    contacts: [{ id: 6, name: 'Frank Thomas', status: "Online", roomId: 2, image: avatar3 }],
  },
  {
    id: 7,
    title: 'G',
    contacts: [{ id: 7, name: 'Gilbert Beer', status: "Offline", roomId: 17 }],
  },
  {
    id: 8,
    title: 'J',
    contacts: [
      { id: 8, name: 'Janette Caster', status: "Online", roomId: 4, image: avatar4 },
      { id: 9, name: 'Joseph Siegel', status: "Online", roomId: 9, image: avatar7 },
      { id: 10, name: 'Justyn Wisoky', status: "Offline", roomId: 18, image: avatar1 }],
  },
  {
    id: 9,
    title: 'K',
    contacts: [{ id: 11, name: 'Keaton King', status: "Online", roomId: 19, image: avatar5 }],
  },
  {
    id: 10,
    title: 'L',
    contacts: [{ id: 12, name: 'Lisa Parker', status: "Offline", roomId: 1, image: avatar2 }],
  },
  {
    id: 11,
    title: 'M',
    contacts: [{ id: 13, name: 'Marian Moen', status: "Online", roomId: 20 }],
  },
  {
    id: 12,
    title: 'N',
    contacts: [{ id: 14, name: 'Nellie Cornett', status: "Online", roomId: 6, image: avatar6 }],
  },
  {
    id: 13,
    title: 'R',
    contacts: [{ id: 15, name: 'Ronald Downey', status: "Online", roomId: 21 , image : avatar6}],
  },
  {
    id: 14,
    title: 'S',
    contacts: [{ id: 16, name: 'Sarah Beattie', status: "Offline", roomId: 5, image: avatar5 }],
  },
  {
    id: 15,
    title: 'V',
    contacts: [{ id: 17, name: 'Victor Beahan', status: "Online", roomId: 22, image: avatar10 }],
  },
  {
    id: 16,
    title: 'W',
    contacts: [{ id: 18, name: 'Wayne Runte', status: "Offline", roomId: 23, image: avatar2 }],
  },
];


console.log("********",messages)


export { chatMessage, messages, attachements, chatContactData };